import React from 'react';
import { Badge } from '../ui/badge';
import { Award, TrendingUp, Users, Settings, Clock, Shield } from 'lucide-react';
import { benefits } from '../../data/mock';

const iconMap = {
  Award,
  TrendingUp,
  Users,
  Settings,
  Clock,
  Shield,
};

export const Benefits = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge className="mb-6 bg-teal-100 text-teal-700 border-teal-200 hover:bg-teal-100">
            Benefícios
          </Badge>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Porquê Investir Num Site Profissional?
          </h2>
          <p className="text-lg text-slate-600">
            Um site bem desenvolvido é o seu melhor vendedor, trabalhando 24 horas por dia para o seu negócio.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit) => {
            const IconComponent = iconMap[benefit.icon];
            return (
              <div
                key={benefit.id}
                className="group text-center p-8 rounded-2xl hover:bg-slate-50 transition-all duration-300 hover:shadow-lg hover:shadow-slate-100"
              >
                <div className="w-16 h-16 mx-auto rounded-2xl bg-teal-100 group-hover:bg-teal-600 flex items-center justify-center mb-6 transition-all duration-300 group-hover:scale-110">
                  <IconComponent className="w-8 h-8 text-teal-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {benefit.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
